import { useCallback, useState } from 'react';

import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { translate } from '@repo/phrase';

import { DiscountSummaryOverview } from './discount-summary-overview/discount-summary-overview.component';
import { PriceSummaryOverview } from './price-summary-overview/price-summary-overview.component';

import styles from '../styles.module.scss';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const AssetPriceSummaryModal = ({ onClose, visible }: Props) => {
    const [slideIndex, setSlideIndex] = useState(0);

    const backButtonCallback = () => {
        setSlideIndex(slideIndex - 1);
    };

    const headerTitle =
        slideIndex === 0 ? translate('asset_price_summary') : translate('asset_price_summary_coupons_and_discounts');

    const onCloseButtonClick = () => {
        setSlideIndex(0);
        onClose();
    };

    const getOverviewContainerClassName = useCallback(
        (index: number) => {
            if (slideIndex === index) {
                return [styles.asset_price_summary_container, styles.active].join(' ');
            }

            return styles.asset_price_summary_container;
        },
        [slideIndex]
    );

    return (
        <Modal handleCloseBtn={onCloseButtonClick} visible={visible}>
            <Sheets
                aria-label={translate('asset_price_summary')}
                header={
                    <ModalHeader
                        ariaBackBtnTxt={translate('button.go_back')}
                        ariaCloseTxt={translate('close')}
                        {...(slideIndex > 0 ? { backBtnClick: backButtonCallback } : {})}
                        title={headerTitle}
                    />
                }
                footer={null}
            >
                <ModalBody className={styles.asset_price_summary_modal_body ?? ''}>
                    <div className={getOverviewContainerClassName(0)}>
                        <PriceSummaryOverview
                            onDiscountsClick={() => {
                                setSlideIndex(1);
                            }}
                        />
                    </div>
                    <div className={getOverviewContainerClassName(1)} style={{ justifyContent: 'flex-start' }}>
                        <DiscountSummaryOverview />
                    </div>
                </ModalBody>
            </Sheets>
        </Modal>
    );
};
